import { Link } from "react-router-dom";
import { Instagram, Store } from "lucide-react";
import { SITE } from "@/config/site";
import { Reveal } from "./motion";

export function FinalCta({ up = false }) {
  const { handle, url } = SITE.instagram;
  return (
    // O rodapé tem uma margem em cima; o -mb (maior do que essa margem) mete este fundo por baixo das festas do rodapé, sem barra branca no meio.
    <section className={`relative isolate ${up ? "-mt-[30px] pt-[30px]" : ""} -mb-[5.25rem] overflow-hidden bg-[#F3E8E4] pb-[1.75rem] text-ink`} data-testid="home-final">
      <img src="/img/hero/encomendas.webp" srcSet="/img/hero/encomendas-800.webp 800w, /img/hero/encomendas.webp 1400w" sizes="100vw" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 -z-10 h-full w-full object-cover" style={{ objectPosition: "50% 76%" }} />
      <span aria-hidden="true" className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,rgba(252,247,244,.74),rgba(246,236,232,.86))]" />

      <Reveal y={12} className="bb-container flex flex-col items-center gap-3 py-6 text-center sm:py-7 lg:py-8">
        <h2 className="bb-h2 max-w-[34ch] text-ink" style={{ fontSize: "clamp(1.3rem, 2.4vw, 2rem)", lineHeight: 1.1 }}>
          Feito à mão, para acompanhar <em className="bb-accent text-bordeaux">os primeiros momentos.</em> <span aria-hidden="true" className="text-bordeaux">♡</span>
        </h2>
        <div className="flex items-center justify-center gap-3">
          <Link to="/loja" data-testid="final-shop" aria-label="Explorar a loja" title="Explorar a loja" className="grid h-12 w-12 place-items-center rounded-full bg-bordeaux text-white shadow-[0_6px_18px_rgba(90,50,56,.25)] transition-transform duration-300 hover:-translate-y-0.5 hover:bg-bordeaux-deep">
            <Store className="h-5 w-5" strokeWidth={1.7} aria-hidden="true" />
          </Link>
          <a href={url} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow" aria-label={`Segue a Babybib em ${handle}`} title={handle} className="grid h-12 w-12 place-items-center rounded-full bg-ivory/90 text-ink ring-1 ring-ink/15 transition-transform duration-300 hover:-translate-y-0.5 hover:text-bordeaux">
            <Instagram className="h-5 w-5" strokeWidth={1.7} aria-hidden="true" />
          </a>
        </div>
      </Reveal>
    </section>
  );
}
